import Link from 'gatsby-link'
import React from 'react'
import Helmet from 'react-helmet'
import styled, { injectGlobal } from 'styled-components'

import logo from '../images/logo-alt.svg'
import theme from '../utils/theme'

import '../styles/index.scss'

injectGlobal`
  body { background-color: ${theme.colors.bg}; }
`

const Site = styled.div`
  display: flex;
  height: 100vh;
`

const Cover = styled.div`
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.667);

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    display: none !important;
  }
`

const Header = styled.header`
  position: fixed;
  z-index: 3;
  left: 0;
  transition: left .2s ease-in-out;
  height: 100%;
  width: ${theme.app.headerWidth};
  max-width: 100vw;
  overflow-y: auto;
  background-color: ${theme.colors.darkBlack};
  border-right: 1px solid #005264;

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    left: 0 !important;
  }
`

const Nav = styled.nav`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  > a {
    padding: 0.5em 1.5em;
    font-family: ${theme.fonts.sans};
    text-decoration: none;
    text-transform: uppercase;
    display: block;
    color: ${theme.colors.lightTeal};
  }
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    padding-left: ${theme.app.headerWidth};
  }
`

const TitleBar = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: ${theme.colors.darkTeal};
  color: white;
  font-size: 1.125rem;
  font-family: ${theme.fonts.sans};
  font-weight: bold;
  border-bottom: 1px solid #005264;

  button {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.25rem;
    border: 1px solid transparent;
    background-color: transparent;
    color: white;
  }

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    display: none;
  }
`

const MainContent = styled.div`
  flex: 1;
  margin-top: 3.125rem;

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    margin-top: auto;
  }
`

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {isShowingHeader: false}
    this.hideHeader = this.hideHeader.bind(this)
    this.showHeader = this.showHeader.bind(this)
  }

  hideHeader() {
    this.setState({isShowingHeader: false})
  }

  showHeader() {
    this.setState({isShowingHeader: true})
  }

  render() {
    const actions = {
      hideHeader: this.hideHeader,
      showHeader: this.showHeader
    }

    return (
      <Site>
        <Helmet>
          <title>{this.props.data.site.siteMetadata.title}</title>
          <link rel="stylesheet" href="https://use.typekit.net/ahw0yta.css"/>
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"/>
          <meta name="google-site-verification" content="gQ5FNjpRFo4pf4wk-Z-xjXrKhFAUrw_Vbsc-d7KcwqE"/>
        </Helmet>
        <Header style={{
          left: this.state.isShowingHeader ? `0` : `-${theme.app.headerWidth}`
        }}>
          <Link to="/" onClick={this.hideHeader}>
            <img src={logo} style={{ padding: `1em 1.5em` }}/>
          </Link>
          <Nav>
            <Link to="/about/" onClick={this.hideHeader}>
              About
            </Link>
            <Link to="/services/" onClick={this.hideHeader}>
              Services
            </Link>
            <Link to="/gallery/" onClick={this.hideHeader}>
              Gallery
            </Link>
            <Link to="/testimonials/" onClick={this.hideHeader}>
              Testimonials
            </Link>
            <Link to="/media/" onClick={this.hideHeader}>
              Media
            </Link>
            <Link to="/contact/" onClick={this.hideHeader}>
              Contact
            </Link>
          </Nav>
        </Header>
        <Main>
          <TitleBar>
            <div>
              <button
                className="link"
                onClick={this.showHeader}>
                <i className="fas fa-bars"></i>
              </button>
            </div>
            <div style={{marginLeft: '0.25rem'}}>
              <Link 
                to="/" onClick={this.hideHeader}
                style={{color: 'white', textDecoration: 'none'}}>
                {this.props.data.site.siteMetadata.title}
              </Link>
            </div>
          </TitleBar>
          <MainContent>
            {this.props.children({...this.props, ...actions})}
          </MainContent>
        </Main>
        <Cover
          onClick={this.hideHeader}
          style={{
            display: this.state.isShowingHeader ? `block` : `none`
          }}>
        </Cover>
      </Site>
    )
  }
}

export default Layout;

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
        phone
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js